import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onDismissButtonClick", "onButtonClick", "children"];
import CUIBox from 'connect-dot-com-ui-components/Components/CUIBox/CUIBox';
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import CUICloseButton from 'connect-dot-com-ui-components/Components/CUICloseButton/CUICloseButton';

/**
 *
 * A floating button that can be used to trigger an action.
 * Note: The parent element should have a position of relative.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CUIFloatingButton(_ref) {
  let {
      onDismissButtonClick,
      onButtonClick,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIBox, {
    pos: "fixed",
    bottom: 6,
    right: 6,
    children: /*#__PURE__*/_jsxs(CUIBox, {
      pos: "relative",
      role: "group",
      children: [/*#__PURE__*/_jsx(CUIButton, Object.assign({
        variant: "primary",
        onClick: onButtonClick,
        boxShadow: "0px 4px 4px 0px #00000040"
      }, rest, {
        children: children
      })), onDismissButtonClick && /*#__PURE__*/_jsx(CUICloseButton, {
        visibility: "hidden",
        _groupHover: {
          visibility: 'visible'
        },
        size: "sm",
        onClick: onDismissButtonClick,
        borderRadius: "full",
        backgroundColor: "black",
        color: "white",
        pos: "absolute",
        top: "-6px",
        right: "-6px"
      })]
    })
  });
}